import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { NavigationStart, Router, RouterEvent } from "@angular/router";

@Component({
  selector: "app-click-and-edit",
  templateUrl: "./click-and-edit.component.html",
  styleUrls: ["./click-and-edit.component.scss"],
})
export class ClickAndEditComponent implements OnInit, OnChanges {
  /**
   * passed input type (textfield | textarea)
   */
  @Input() type: string;
  @Input() break: boolean;
  /**
   * passed value of model
   */
  @Input() value: string;
  /**
   * name of model attribute to change
   */
  @Input() name: string;
  @Input() required: boolean = true;
  /**
   * passed model to save
   */
  @Input() model: Object;
  textField: string = "textfield";
  textArea: string = "textarea";
  textAreaWithoutStyling: string = "basic-textarea";
  clicked: boolean = false;
  /**
   * passed function to execute by clicking ok
   */
  @Input() toggleAction: Function;

  @Input() id: any;

  /**
   * Text to display as placeholder
   */
  @Input() placeholder: string = "Beschreibung hinzufügen...";

  @ViewChild("clickandeditinput2") input2: ElementRef;
  @ViewChild("clickandeditinput3") input3: ElementRef;
  @ViewChild("clickandeditinput1") input1: ElementRef;

  tempValue: any;
  nameEmpty: boolean;

  constructor(private router: Router) {
    // router.events.subscribe((event: RouterEvent) => {
    //   if (event instanceof NavigationStart) {
    //     // Show loading indicator
    //     this.saveValue();
    //   }
    // });
  }

  ngOnInit() {
    // console.log("init aufgerufen");
    this.tempValue = this.value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["id"]) {
      this.tempValue = this.value;
    }
  }

  /**
   * set new value to model and executes passed function
   */
  saveValue() {
    if (!this.clicked) return;
    if (!this.required || this.value || this.type === "textarea") {
      if (this.value === "<br>") {
        this.value = "";
      }
      if (
        this.required &&
        this.type !== "textarea" &&
        this.value.trim() === ""
      ) {
        this.cancelEdit();
      }
      this.nameEmpty = false;
      this.model["" + this.name] = this.value;
      if (this.toggleAction) this.toggleAction(this.model);
      this.clicked = false;
      this.tempValue = this.value;
    } else {
      this.nameEmpty = true;
    }
  }

  cancelEdit() {
    this.clicked = false;
    this.value = this.tempValue;
  }

  resizeText(element) {
    $(element).trigger("autoresize");
    if (this.input2 && this.clicked) {
      setTimeout(() => this.input2.nativeElement.focus(), 0);
    }
    if (this.input3) {
      setTimeout(() => this.input3.nativeElement.focus(), 0);
    }
    if (this.input1) {
      setTimeout(() => this.input1.nativeElement.focus(), 0);
    }
  }

  saveValueOnce() {
    if (this.clicked) {
      this.saveValue();
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/click-and-edit/click-and-edit.component.ts